<template>
    <div class="web-profile-container">
        <template v-if="loading">
            <WebProfileSkeleton />
        </template>
        <template v-else>
            <el-main class="profile-content">
                <WebProfileHeader />
                <ClaimSection />
                <UrlSection />
                <MetaTitleSection />
                <MetaSection />
                <SummarySection />
                <DetailCompetencesSection />
                <IndustrySectorsSection />
                <JobTagsSection />
                <ProjectsSection />
                <EducationSection />
                <PublicationsSection />
            </el-main>
        </template>
    </div>
</template>

<script>
import { useWebProfileStore } from "@/stores/WebProfileStore";
import { mapStores } from "pinia";

import WebProfileSkeleton from "./Components/WebProfileSkeleton.vue";
import WebProfileHeader from "./Components/WebProfileHeader.vue";
import ClaimSection from "./Components/ClaimSection.vue";
import UrlSection from "./Components/UrlSection.vue";
import MetaTitleSection from "./Components/MetaTitleSection.vue";
import MetaSection from "./Components/MetaSection.vue";
import SummarySection from "./Components/SummarySection.vue";
import DetailCompetencesSection from "./Components/DetailCompetencesSection.vue";
import IndustrySectorsSection from "./Components/IndustrySectorsSection.vue";
import JobTagsSection from "./Components/JobTagsSection.vue";
import ProjectsSection from "./Components/ProjectsSection.vue";
import EducationSection from "./Components/EducationSection.vue";
import PublicationsSection from "./Components/PublicationsSection.vue";

export default {
    name: "WebProfile",
    components: {
        WebProfileSkeleton,
        WebProfileHeader,
        ClaimSection,
        UrlSection,
        MetaTitleSection,
        MetaSection,
        SummarySection,
        DetailCompetencesSection,
        IndustrySectorsSection,
        JobTagsSection,
        ProjectsSection,
        EducationSection,
        PublicationsSection,
    },
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        ...mapStores(useWebProfileStore),
    },

    methods: {
        async fetchData() {
            if (this.$profileId) {
                this.loading = true;
                try {
                    await this.WebProfileStore.fetchWebProfileData(
                        this.$profileId
                    );
                } catch (error) {
                    console.error("Error fetching profile:", error);
                } finally {
                    this.loading = false;
                }
            } else {
                console.error(
                    "WebProfile component is missing the 'profileId' prop."
                );
            }
        },
    },
    created() {
        this.fetchData();
    },
};
</script>

<style>
.web-profile-container {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.profile-header {
    flex-shrink: 0;
}

.profile-content {
    display: flex;
    flex-direction: column;
    padding: 20px;
    flex-grow: 1;
    overflow-y: auto;
    min-height: 0;
}

.el-message--success {
  color: #135d23;
  background-color: #d3f0d9;
  border-color: #c2eaca;
}

.el-message--error {
  color: #7d2c38;
  background-color: #fcdde2;
  border-color: #fbcfd6;
}

.el-message--info {
  color: #274777;
  background-color: #dbe7fa;
  border-color: #cddef7;
}


</style>
